import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { withStore } from "store/storeHandler";
import WrongPathErrorView from "presentational/error/WrongPathErrorView";
import { isValidInput } from "lib/textFilter";
import Restful from "lib/restful";
import config from "lib/fr-config";
import { getFullUrl, getEssentialUrl } from "lib/urlQueryParser";
import PropTypes from "prop-types";

const REFERRAL_QUERY_INDEX = config.referralUrlQueryIndex;

RootShortcutPortfolioHash.propTypes = {
  userHash: PropTypes.string.isRequired
};

function RootShortcutPortfolioHash(props) {
  const { userHash, hasLoggedIn, AppErrorActions } = props;
  const [validType, setValidType] = useState("pending"); // "pending", "invalid"

  const history = useHistory();

  useEffect(() => {
    isValidShortcutText();
  }, []);

  const isValidShortcutText = async () => {
    const isValid = isValidInput("userHash", userHash);
    if (!isValid) {
      setValidType("invalid");
      return null;
    }

    let username;
    const { code, res, errInfo } = await Restful.getUsernameFromUserHashAPI({
      userHash
    });
    if (code === "error") {
      const { apiName, data, httpCode, message } = errInfo;
      const errObj = Error("username request error");
      errObj.errorValue = { apiName, data, httpCode, message, userHash };
      AppErrorActions.setSafeAppError(errObj);
      history.replace(getEssentialUrl({ type: "opening" })());
      return null;
    } else {
      username = res.username;
    }

    if (!username) {
      setValidType("invalid");
      return null;
    } else {
      history.replace(getNextUrl(username));
    }
  };

  const getNextUrl = username => {
    const { refUsername } = REFERRAL_QUERY_INDEX;

    const nextUrl = getFullUrl({
      url: getEssentialUrl({ type: "portfolio" })(username),
      queryObj: { [refUsername]: hasLoggedIn ? undefined : username }
    });
    return nextUrl;
  };

  return (
    <React.Fragment>
      {validType === "invalid" && <WrongPathErrorView />}
    </React.Fragment>
  );
}

export default withStore({
  stateMap: { myAccount: ["hasLoggedIn"] },
  dispatchMap: ["appError"]
})(RootShortcutPortfolioHash);
